import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import styles from "./DeleteContactConfirmModal.module.scss"

interface DeleteContactConfirmModalProps {
  show: boolean
  contactCount: number
  onCancel: () => void
  onConfirm: () => void
}

const DeleteContactConfirmModal = ({
  show,
  contactCount,
  onCancel,
  onConfirm,
}: DeleteContactConfirmModalProps) => {
  const [confirmText, setConfirmText] = useState("")
  const isConfirmed = confirmText === "DELETE"
  const confirmationMessage =
    contactCount === 1
      ? "Deleting this contact will delete them from all events they are invited from as well."
      : "Deleting these contacts will delete them from all events they are invited from as well."

  useEffect(() => {
    if (!show) {
      setConfirmText("")
    }
  }, [show])

  const handleConfirm = () => {
    if (!isConfirmed) {
      return
    }

    onConfirm()
    setConfirmText("")
  }

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header className={styles.close} closeButton></Modal.Header>
      <Modal.Body>
        <div className={styles.body}>
          <h2 className={`caption ${styles.caption}`}>Delete contact</h2>
          <span className={styles.text}>{confirmationMessage}</span>
          <span className={styles.text}>
            Type <span className={styles.confirmWord}>DELETE</span> to confirm.
          </span>

          <div className={`profile-input ${styles.input}`}>
            <input
              id="delete-contact-confirmation"
              type="text"
              value={confirmText}
              onChange={(event) => setConfirmText(event.target.value)}
              autoFocus
            />
            <label htmlFor="delete-contact-confirmation">DELETE</label>
          </div>

          <div className={styles.controls}>
            <button type="button" className="btn btn-simple" onClick={onCancel}>
              Cancel
            </button>
            <button
              type="button"
              className={`btn btn-dark ${styles.deleteButton}`}
              disabled={!isConfirmed}
              onClick={handleConfirm}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DeleteContactConfirmModal
